import { GuestRepository } from '../../domain/repository';
import { GuestRepositoryImpl } from '../repository';

export const guestProviders = [
  {
    provide: GuestRepository,
    useExisting: GuestRepositoryImpl,
  },
];



